import { defineMessages } from 'react-intl';

const messages = defineMessages({
  driverTip: {
    description: 'fulfillmentPlanner.driverTip.label',
    defaultMessage: 'Driver Tip',
    id: 'aEXUZR',
  },
  driverTipTooltip: {
    description: 'fulfillmentPlanner.driverTip.tooltip',
    defaultMessage: 'Local Delivery drivers respond to better tips.',
    id: 'IrQlgy',
  },
});

export default messages;
